import {
  Alert, AlertTitle, Button, List, ListItem, Stack
} from '@mui/material';
import { FC, memo } from 'react';

// 警告は行を落としていない。取り込めるが読んでおいてほしいことなので、
// 「このまま取り込む」を押してもらってから次へ進む（設計書 #405）
const RuleWarnings: FC<{
  warnings: string[];
  onAccept: () => void;
}> = memo(({ warnings, onAccept }) => (
  <Alert severity="warning">
    <AlertTitle>取り込めますが、確認してください</AlertTitle>
    <List dense disablePadding>
      {warnings.map((warning) => (
        <ListItem key={warning} disableGutters sx={{ display: 'list-item', listStyleType: 'disc', ml: 2 }}>
          {warning}
        </ListItem>
      ))}
    </List>
    <Stack direction="row" justifyContent="flex-end" pt={1}>
      <Button variant="contained" size="small" onClick={onAccept}>このまま取り込む</Button>
    </Stack>
  </Alert>
));

export default RuleWarnings;
